import React from 'react'

import { NavLinkProps, NavLink as RRNavLink } from 'react-router-dom'

const FwdRefNavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>(function NavLink(props, ref) {
  return (
    <RRNavLink
      innerRef={ref}
      {...props}
    />
  )
})

export default FwdRefNavLink
